import { createUseStyles } from "react-jss";

const useStyles = createUseStyles((theme: any) => ({
  title: {
    fontWeight: '600',
  },
  text: {
    marginTop: '16px',
    marginBottom: '0px',
    color: theme.colors.grey[650],
    fontSize: '14px',
    maxWidth: '90%',
    '& a': {
      color: theme.colors.primaryBlue[500],
    },
    '& > div': {
      marginTop: '16px',
      width: '100%',
      '& + p': {
        marginTop: '16px',
      },
    },
    '& > ul': {
      listStyleType: 'none',
      marginBlockStart: '0',
      paddingInlineStart: '0',
      '& > li': {
        display: 'flex',
        alignItems: 'center',
        gap: '6px',
        '& > svg': {
          width: '12px',
          height: '12px',
          minWidth: '12px',
          minHeight: '12px',
        },
        '&.grey': {
          color: theme.colors.grey[650],
          '& > svg': {
            width: '6px',
            height: '6px',
            minWidth: '6px',
            minHeight: '6px',
          },
        },
        '&.green': {
          color: theme.colors.systemGreen[500],
        },
        '&.red': {
          color: theme.colors.systemRed[500],
        },
      },
    },
  },
  footer: {
    display: "flex",
    justifyContent: "flex-end",
    marginTop: "20px",
  },
  row: {
    display: 'flex',
    flexDirection: 'row',
    flexWrap: 'wrap',
    '&:not(:first-of-type)': {
      marginTop: '32px',
    },
    [theme.breakpoints.down('md')]: {
      flexDirection: 'column',
      alignItems: 'center',
    },
  },
  block: {
    display: 'flex',
    flexDirection: 'column',
    flex: '0 0 50%',
    [theme.breakpoints.down('md')]: {
      width: '100%',
      flex: '0 0 100%',
      alignItems: 'center',
      '& + div': {
        marginTop: '16px',
      },
    },
  },
}));

export default useStyles;